import { createFormItem } from "@/component-create/utils/create-form-item";
import { FORM_ITEM } from "@/components/form/enums";

export const searchFormItems = [
  createFormItem('任务编号', 'taskId', FORM_ITEM.INPUT),
  createFormItem('任务名称', 'taskName', FORM_ITEM.INPUT),
  createFormItem('任务状态', 'status', FORM_ITEM.SELECT, { loader: 'ASYN_TASK_STATUS',allOption: true})
]
